import { getOccupancyText } from 'components/Recommendations/utils/getOccupancyText'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { createSelector } from 'reselect'

import { DAY_FORMAT, DAY_MONTH_NAME_SHORT, DMY_CASUAL_SHORT_FORMAT } from 'constants/dateFormats'

export const getCurrenctOccupancyLabel = createSelector(
  (offerPageState: OfferPageState) => offerPageState.offer!,
  (offerPageState: OfferPageState) => offerPageState.rooms,
  (offer, rooms) => {
    const roomOccupants = rooms || [generateRoomOccupants()]
    return getOccupancyText(roomOccupants, offer.saleUnit)
  },
)

export const getCurrentDateLabel = createSelector(
  (offerPageState: OfferPageState) => offerPageState.checkInDate,
  (offerPageState: OfferPageState) => offerPageState.duration,
  (checkIn, duration) => {
    if (!checkIn) return ''

    const checkOut = checkIn.clone().add(duration, 'days')
    if (checkIn.isSame(checkOut, 'month')) {
      return `${checkIn.format(DAY_FORMAT)} - ${checkOut.format(DMY_CASUAL_SHORT_FORMAT)}`
    } else if (checkIn.isSame(checkOut, 'year')) {
      return `${checkIn.format(DAY_MONTH_NAME_SHORT)} - ${checkOut.format(DMY_CASUAL_SHORT_FORMAT)}`
    } else {
      return `${checkIn.format(DMY_CASUAL_SHORT_FORMAT)} - ${checkOut.format(DMY_CASUAL_SHORT_FORMAT)}`
    }
  },
)

export const getDatesOccupancyLabel = createSelector(
  getCurrentDateLabel,
  getCurrenctOccupancyLabel,
  (dateLabel, occupancyLabel) => {
    return `${dateLabel}, ${occupancyLabel}`
  },
)
